import { render, staticRenderFns } from "./result-card.vue?vue&type=template&id=1f0b0d4c"
import script from "./result-card.vue?vue&type=script&lang=js"
export * from "./result-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports